/**
 * @returns {boolean}
 */
const DEBUG = () => {
    return localStorage.getItem("debug")
}

export default DEBUG